import { Pipe, PipeTransform} from '@angular/core';


@Pipe({ name: 'firstNamePipe' })

export class FirstNamePipe implements PipeTransform {

    transform(userLogin: string):  string {
        const info: string[] = userLogin.split('.');
        return '' + info[0].charAt(0).toUpperCase() + info[0].slice(1);
    }
}
